export default {
  Title: 'Ετικέτες | Ετικέτα | Ετικέτες',

  SelectTagDialog: {
    Title   : 'Ετικέτες',
    Subtitle: 'Επιλέξτε ετικέτα'
  },

  Message: {
    NoItems: {
      Title   : 'Δεν υπάρχουν διαθέσιμα προϊόντα',
      Subtitle: 'Επιλέξτε μια άλλη ετικέτα απο το μενού'
    }
  }
}
